import React from 'react'
import { pxToRem } from 'theme'
import { Dialog } from 'components/Dialog'
import Card from 'components/Card'
import Button from 'components/Button'
import { Text } from 'components/Typography'

interface Props {
  isOpen?: boolean
  onDismiss: () => void
  onDelete: () => void
}

export const DeleteEventDialog: React.VFC<Props> = ({ isOpen, onDismiss, onDelete }) => (
  <Dialog isOpen={isOpen} onDismiss={onDismiss} maxWidth={pxToRem(500)}>
    <Card>
      <Card.Title onDismiss={onDismiss}>Delete Event</Card.Title>
      <Card.Content display="grid" gridGap="1rem">
        <Text> Are you sure you want to delete this Event?</Text>
      </Card.Content>
      <Card.Actions>
        <Button colorVariant="secondary" mr="0.25rem" onClick={onDismiss}>
          Cancel
        </Button>
        <Button color="danger" onClick={onDelete}>
          Delete
        </Button>
      </Card.Actions>
    </Card>
  </Dialog>
)
